import { trackEvent } from './analytics';

// This auxiliary event uses existing GA dimensions. The property has no free
// custom-dimension slots, so raw boolean parameters alone cannot be reported.
export function recordingDiagnosticMeasurements(diagnostics = {}) {
  const source = ['mic','tab','tab-mic'].includes(diagnostics.recording_source) ? diagnostics.recording_source : 'unknown';
  const surface = ['browser','window','monitor'].includes(diagnostics.capture_surface) ? diagnostics.capture_surface : 'unknown';
  const kinds = source === 'tab-mic' ? ['mic','tab'] : source === 'unknown' ? [] : [source];
  const state = kind => diagnostics[`${kind}_signal_measured`] !== true ? 'unmeasured'
    : diagnostics[`${kind}_low_signal`] === true ? 'low'
      : diagnostics[`${kind}_signal_detected`] === true ? 'sound' : 'quiet';
  return { result_state: kinds.map(kind => `${kind}_${state(kind)}`).join('_') || 'unknown',
    event_source: `recording_${source.replace('-', '_')}_${surface}` };
}

export function trackRecordingDiagnostics(operation, diagnostics) {
  if (!['recording_stop','recording_audio_check'].includes(operation)) return false;
  return trackEvent('recording_source_diagnostics', { operation, ...recordingDiagnosticMeasurements(diagnostics) });
}
